import React from 'react';
const SvgXltxThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 96 96" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M82 12V6H24v78h6v6h58V12z" />
      <path fill="#217346" d="M82 6H24v12h58v-8l6 6v-4z" />
      <path fill="#949494" d="M86 14v74H32v-4h50V18h-2v64H26V18h-2v66h6v6h58V16z" />
      <path fill="#217346" d="M8 34l40-6v52L8 74z" />
      <path
        fill="#FFF"
        d="M37.94 66h-5.746l-3.706-7.49c-.14-.278-.285-.791-.435-1.54h-.06c-.07.353-.235.888-.495 1.604L23.777 66H18l6.857-11.5L18.585 43h5.897l3.076 6.897c.24.545.455 1.192.645 1.94h.06c.12-.449.345-1.117.675-2.004L32.36 43h5.402l-6.452 11.404L37.941 66z"
      />
      <path
        fill="#C8C8C8"
        d="M60 72h14v4H60zM48 72h8v4h-8zM60 64h14v4H60zM48 64h8v4h-8zM60 56h14v4H60zM48 56h8v4h-8zM60 48h14v4H60zM48 48h8v4h-8zM60 40h14v4H60zM48 40h8v4h-8zM60 32h14v4H60zM48 32h8v4h-8z"
      />
      <linearGradient id="xltx-thumbnail_svg__a" gradientUnits="userSpaceOnUse" x1={28} y1={78.375} x2={28} y2={29.517}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.859} stopColor="#fff" stopOpacity={0.155} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.18} />
      </linearGradient>
      <path fill="url(#xltx-thumbnail_svg__a)" d="M48 28L8 34v40l40 6z" />
      <linearGradient
        id="xltx-thumbnail_svg__b"
        gradientUnits="userSpaceOnUse"
        x1={35.508}
        y1={85.837}
        x2={36.355}
        y2={77.86}
      >
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.17} stopColor="#7e7e7e" stopOpacity={0.034} />
        <stop offset={0.346} stopColor="#717171" stopOpacity={0.069} />
        <stop offset={0.525} stopColor="#5d5d5d" stopOpacity={0.105} />
        <stop offset={0.706} stopColor="#404040" stopOpacity={0.141} />
        <stop offset={0.886} stopColor="#1b1b1b" stopOpacity={0.178} />
        <stop offset={0.997} stopOpacity={0.2} />
      </linearGradient>
      <path fill="url(#xltx-thumbnail_svg__b)" d="M48 86H24v-9.6L48 80z" />
      <linearGradient
        id="xltx-thumbnail_svg__c"
        gradientUnits="userSpaceOnUse"
        x1={25.998}
        y1={16.439}
        x2={80.002}
        y2={85.561}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#xltx-thumbnail_svg__c)" d="M24 18h58v66H24z" />
      <linearGradient
        id="xltx-thumbnail_svg__d"
        gradientUnits="userSpaceOnUse"
        x1={46.856}
        y1={37.457}
        x2={87.943}
        y2={90.045}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#xltx-thumbnail_svg__d)" d="M82 10v74H30v6h58V16z" />
      <linearGradient id="xltx-thumbnail_svg__e" gradientUnits="userSpaceOnUse" x1={56} y1={89.813} x2={56} y2={84.175}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#xltx-thumbnail_svg__e)" d="M30 84h52v6H30z" />
      <linearGradient
        id="xltx-thumbnail_svg__f"
        gradientUnits="userSpaceOnUse"
        x1={55.678}
        y1={17.154}
        x2={56.331}
        y2={4.68}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#xltx-thumbnail_svg__f)" d="M82 6H24v12h58v-8l6 6v-4z" />
    </svg>
  );
});
export default SvgXltxThumbnail;
SvgXltxThumbnail.iconName = 'xltx-thumbnail';
SvgXltxThumbnail.displayName = 'SvgXltxThumbnail';
